module.exports = { id: "windmill", url: "/build/app/img/symbols.svg#windmill", viewBox: "", toString: function() { return this.url; } };